var Currency;

(function (Currency) {
  Currency["USD"] = "currency/usd";
  Currency["GBP"] = "currency/gbp";
  Currency["CAD"] = "currency/cad";
})(Currency || (Currency = {}));

var Numeric;

(function (Numeric) {
  Numeric["Percentage"] = "numeric-class/percentage";
  Numeric["PositiveInteger"] = "numeric-class/positive-integer";
  Numeric["PositiveDecimal"] = "numeric-class/positive-decimal";
})(Numeric || (Numeric = {}));

var Finance;

(function (Finance) {
  Finance["Expenses"] = "finance/expenses";
  Finance["Revenues"] = "finance/revenues";
  Finance["Assets"] = "finance/assets";
  Finance["Liabilities"] = "finance/liabilities";
  Finance["Equities"] = "finance/equities";
})(Finance || (Finance = {}));

var Check;

(function (Check) {
  Check["Amount"] = "check-data/check-amount";
  Check["Department"] = "check-data/department";
  Check["PaidTo"] = "check-data/paid-to";
  Check["Date"] = "check-data/check-date";
  Check["CheckNo"] = "check-data/check-no";
  Check["ExpenseType"] = "check-data/expense-type";
  Check["VoucherID"] = "check-data/voucher-id";
  Check["VendorCity"] = "check-data/vendor-city";
  Check["VendorState"] = "check-data/vendor-state";
  Check["VendorZip"] = "check-data/vendor-zip";
  Check["Fund"] = "check-data/fund";
  Check["Program"] = "check-data/program";
  Check["Ali"] = "check-data/ali";
  Check["DocumentID"] = "check-data/--zz0x-document-id";
  Check["Expense"] = "check-data/--zz0x-expense";
})(Check || (Check = {}));

var Geometry;

(function (Geometry) {
  Geometry["Point"] = "geometry/point";
  Geometry["Linestring"] = "geometry/linestring";
  Geometry["Polygon"] = "geometry/polygon";
  Geometry["MultiPoint"] = "geometry/multi-point";
  Geometry["MultiLinestring"] = "geometry/multi-linestring";
  Geometry["MultiPolygon"] = "geometry/multi-polygon";
})(Geometry || (Geometry = {}));

var Metadata;

(function (Metadata) {
  Metadata["Label"] = "metadata/label";
  Metadata["Description"] = "metadata/description";
  Metadata["AllConcat"] = "metadata/all-concat";
})(Metadata || (Metadata = {}));

var Period;

(function (Period) {
  Period["GregorianMonthNumeric"] = "period/gregorian-month-numeric";
  Period["GregorianYearNumeric"] = "period/gregorian-year-numeric";
  Period["FiscalMonth"] = "period/fiscal-month";
  Period["FiscalYear"] = "period/fiscal-year";
  Period["FiscalQuarter"] = "period/fiscal-quarter";
})(Period || (Period = {}));

var Dimension;

(function (Dimension) {
  Dimension["Key"] = "dimension/key";
  Dimension["Column"] = "dimension/column";
})(Dimension || (Dimension = {}));

var Hierarchy;

(function (Hierarchy) {
  Hierarchy["Attribute"] = "hierarchy/attribute";
})(Hierarchy || (Hierarchy = {}));

var Account;

(function (Account) {
  Account["Ignored"] = "account/ignored";
})(Account || (Account = {}));

var SystemGenerated = 'system-generated';
export var SemanticTypes = {
  Account: Account,
  Check: Check,
  Currency: Currency,
  Dimension: Dimension,
  Finance: Finance,
  Geometry: Geometry,
  Hierarchy: Hierarchy,
  Metadata: Metadata,
  Numeric: Numeric,
  Period: Period,
  SystemGenerated: SystemGenerated
};